var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.count, function(i) {
      return _c(
        "div",
        { key: i },
        [
          _c(
            "vue-content-loading",
            { attrs: { width: 400, height: 90, preserveAspectRatio: "none" } },
            [
              _c("rect", {
                attrs: {
                  x: "0",
                  y: "20",
                  rx: "4",
                  ry: "4",
                  width: "90",
                  height: "60"
                }
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "110",
                  y: "30",
                  rx: "4",
                  ry: "4",
                  width: "200",
                  height: "20"
                }
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "110",
                  y: "60",
                  rx: "4",
                  ry: "4",
                  width: "200",
                  height: "10"
                }
              })
            ]
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4197880e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4197880e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/newsByInterests/NewsFeedLoadingSkeleton.vue
// module id = null
// module chunks = 